import React, {useEffect, MouseEvent} from 'react';
import classNames from 'classnames';
import {callOpenSubscriptionWebview} from '@src/utils/scheme';
import {HELP_URL, INQUIRY_URL, PRIVACY_POLICY_URL} from '@src/constants';
import {TIARA_ACTION_NAME} from '@src/constants/tiara';

const NOTICE_URL = process.env.NEXT_PUBLIC_NOTICE_URL || '';
const TERMS_URL = process.env.NEXT_PUBLIC_TERMS_URL || '';
const KAKAO_CORP_URL = 'https://www.kakaocorp.com';
const REPORT_NUMBER_URL = 'https://www.ftc.go.kr/bizCommPop.do?wrkr_no=1208147521';
const KAKAO_CHAT_URL = 'http://pf.kakao.com/_pdxgxmxj/chat';

interface IFooter {
  isFolded: boolean;
  setIsFolded: React.Dispatch<React.SetStateAction<boolean>>;
  scrollToBottom: () => void;
}

function Footer ({isFolded = true, setIsFolded, scrollToBottom}: IFooter) {
  const handleClickTermsOfService = (event: MouseEvent) => {
    event.preventDefault();
    callOpenSubscriptionWebview(TERMS_URL);
  };
  const handleClickNotice = (event: MouseEvent) => {
    event.preventDefault();
    callOpenSubscriptionWebview(NOTICE_URL);
  };
  const handleClickHelp = (event: MouseEvent) => {
    event.preventDefault();
    callOpenSubscriptionWebview(HELP_URL);
  };
  const handleClickPrivacyPolicy = (event: MouseEvent) => {
    event.preventDefault();
    callOpenSubscriptionWebview(PRIVACY_POLICY_URL);
  };
  const handleClickKakaoCorp = (event: MouseEvent) => {
    event.preventDefault();
    callOpenSubscriptionWebview(KAKAO_CORP_URL);
  };
  const handleClickReportNumber = (event: MouseEvent) => {
    event.preventDefault();
    callOpenSubscriptionWebview(REPORT_NUMBER_URL);
  };
  const handleClickInquiry = (event: MouseEvent) => {
    event.preventDefault();
    callOpenSubscriptionWebview(INQUIRY_URL);
  };

  useEffect(() => {
    if (!isFolded) {
      scrollToBottom();
    }
  }, [isFolded, scrollToBottom]);

  return (
    <footer className="doc-footer">
      <div className="service_info">
        <strong className="screen_out">서비스 이용정보</strong>
        <ul>
          <li>
            <a href="#none" onClick={handleClickTermsOfService} className="link_info">
              이용약관
            </a>
          </li>
          <li>
            <a href="#none" onClick={handleClickPrivacyPolicy} className="link_info">
              <em className="txt_emph">개인정보처리방침</em>
            </a>
          </li>
          <li>
            <a href="#none" onClick={handleClickNotice} className="link_info">
              {' '}
              공지사항{' '}
            </a>
          </li>
          <li>
            <a href="#none" onClick={handleClickHelp} className="link_info">
              도움말
            </a>
          </li>
        </ul>
        <small>
          (주)카카오는 통신판매중개시스템의 제공자로 통신판매의 당사자가 아니며 상품의 주문 배송 및 환불 등과 관련한
          의무와 책임은 각 판매자에게 있습니다.
        </small>
      </div>
      <div className="provider_info">
        <small>
          <a href="#none" className="link_kakao" onClick={handleClickKakaoCorp}>
            © Kakao Corp.
          </a>
        </small>
        {/* <!-- 펼치기 클릭시 on 클레스 추가 --> */}
        <button
          type="button"
          className={classNames('btn_provider', {on: !isFolded})}
          onClick={() => setIsFolded(prevIsOpen => !prevIsOpen)}
        >
          {' 사업자 정보 '}
          <i className="ico_g">펼치기/접기</i>
        </button>
        {/* <!-- 2022-02-08 푸터영역 수정 --> */}
        <dl className="list_provider">
          {/* <!-- 2021-08-27 수정시작 : 정보 항목 추가 --> */}
          <dt>대표</dt>
          <dd>정신아</dd>
          <dt>주소</dt>
          <dd>
            <address>제주특별자치도 제주시 첨단로 242 (영평동)</address>
          </dd>
          <dt>호스팅사업자</dt>
          <dd>(주)카카오</dd>
          <dt>사업자등록번호</dt>
          <dd>120-81-47521</dd>
          <dt>통신판매업신고번호</dt>
          <dd>
            <a href="#none" className="link_info" onClick={handleClickReportNumber}>
              제2015-제주아라-0032호
            </a>
          </dd>
          <dt>이메일</dt>
          <dd>
            <a href="mailto:subscription_cs@kakaocorp.com" className="link_info">
              subscription_cs@kakaocorp.com
            </a>
          </dd>
          {/* <!-- // 2021-08-27 수정끝 : 정보 항목 추가 --> */}
          <dt>고객센터</dt>
          <dd>
            {' '}
            <a href={KAKAO_CHAT_URL} data-tiara-action-name={TIARA_ACTION_NAME.BUTTON_TALK_CONSULTING_CLICK}>
              <span className="ico_g_bf btn_talk">톡상담</span>
            </a>
            <a
              href="#none"
              onClick={handleClickInquiry}
              data-tiara-action-name={TIARA_ACTION_NAME.BUTTON_INQUIRY_LAUNCHING_CLICK}
            >
              <span className="ico_g_bf btn_ask">문의하기</span>
            </a>{' '}
          </dd>
        </dl>
        {/* <!-- // 2022-02-08 푸터영역 수정 --> */}
      </div>
    </footer>
  );
}

export default Footer;
